export default __webpack_public_path__ + "static/media/weatherdash.dd803098.png";